export interface IProject {
  projectName: string;
  sowNumber: string;
}

// ---------------------- User

export interface IUser {
  systemUserId: string | null;
  firstName: string | null;
  lastName: string | null;
  fullName: string | null;
  internalEmailAddress: string | null;
  bookableResourceId: string | null;
}

// ---------------------- Booking

export interface IBooking {
  bookingStatusName: string | null;
  appointmentName: string | null;
  resourceRequirementName: string | null;
  workOrderName: string | null;
  workOrderId: string | null;
  bookingId: string | null;
  duration: number;
  endTime: Date;
  startTime: Date;
  localEndTime: Date;
  localStartTime: Date;
  weekday: number;
  bookingStatus: string | null;
  bookingProgress: string | null;
  city: string | null;
  state: string | null;
  clientRoom: string | null;
  serviceAccountName: string | null;
  projectName: string | null;
  serviceRequestName: string | null;
  ownerName: string | null;
  street: string | null;
  instructions: string | null;
  postalCode: string | null;
  sowNumber: string | null;
}

export interface IBookingCalendar extends IBooking {
  scnNumber: string | null;
}

export interface IBookingStatusReason {
  attributeValue: number;
  reason: string | null;
}

export enum BookingStatus {
  Scheduled = "f16d80d1-fd07-4237-8b69-187a11eb75f9",
  InProgress = "53f39908-d08a-4d9c-90e8-907fd7bec07d",
  OnBreak = "ef3164b9-0893-4032-9bb2-0f2e58f982af",
  Completed = "c33410b9-1abe-4631-b4e9-6e4a1113af34",
  FollowUp = "289f20ee-6fc5-eb11-a986-005056ad0c7f",
}

export enum BookingStatusLabel {
  Missed = "missed",
  CheckedIn = "checked-in",
  Late = "late",
}

// ---------------------- Work Order

export interface IWorkOrder {
  serviceAccountName: string | null;
  serviceTerritoryName: string | null;
  projectName: string | null;
  workOrderTypeName: string | null;
  address1: string | null;
  city: string | null;
  stateOrProvince: string | null;
  latitude: number;
  longitude: number;
  postalCode: string | null;
  serviceRequestName: string | null;
  serviceRequestId: string | null;
  instructions: string | null;
  workOrderId: string | null;
  systemStatus: number;
  ownerId: string | null;
  sowNumber: string | null;
  project: string | null;
  siteContact: string | null;
  opportunityIdName: string | null;
  opportunityId: string | null;
  dispatchInstructions: string | null;
  workOrderName: string | null;
  endTime: Date;
  startTime: Date;
  localEndTime: Date;
  localStartTime: Date;
  workOrderBookingId: string | null;
  bookingStatus: string | null;
  resource: string | null;
  summaryLength: number;
  nextStepsLength: number;
  resolutionLength: number;
}

export interface IWorkOrderNotes {
  subject: string | null;
  fileName: string | null;
  noteText: string | null;
  createdOn: string | null;
}

export interface IWorkOrderPosts {
  text: string | null;
  createdOn: string | null;
  modifiedOn: string | null;
  source: number;
  type: number;
}

export interface IWorkOrderContact {
  fullName: string | null;
  email: string | null;
  mobilePhone: string | null;
  telephone: string | null;
}

export interface IWorkOrderOwnerProject {
  ownerId: string | null;
  ownerName: string | null;
  firstName: string | null;
  lastName: string | null;
  emailAddress: string | null;
  constructionType: number;
}

export interface IWorkOrderOwnerIncident {
  ownerId: string | null;
  ownerName: string | null;
  ticketNumber: string | null;
}

export interface IWorkOrderOtherTech {
  bookingStatus: string | null;
  startTime: Date;
  endTime: Date;
  localStartTime: Date;
  localEndTime: Date;
  bookableResourceBookingId: string | null;
  resource: string | null;
  resourceName: string | null;
  estimatedArrivalTime: Date;
  latitude: number;
  longitude: number;
  bookingStatusName: string | null;
}

// ---------------------- Location

interface IAddressDetails {
  house_number?: string;
  road?: string;
  suburb?: string;
  city?: string;
  state?: string;
  postcode?: string;
  country?: string;
  display_name: string;
}

export interface IGeolocation {
  latitude: number;
  longitude: number;
  address: IAddressDetails;
  deviceType: string;
}

// ---------------------- Error

export interface IProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  traceId?: string;
  timestamp?: string;
  instance?: string;
  errors?: Record<string, string[]>;
  [key: string]: any;
}

export interface IApiError extends Error {
  status: number;
  statusText: string;
  url: string;
  method: string;
  problemDetails?: IProblemDetails;
  data?: any;
}

// ---------------------- Check Out

export interface ICheckoutRequest {
  checkoutType: string;
  workOrderId: string;
  workOrderName: string;
  ownerId: string;
  bookingId: string;
  userId: string;
  userName: string;
  latitude: number;
  longitude: number;
  address: string;
  deviceType: number;
  actionsTaken: string;
  nextSteps: string;
  resolutionDetails: string;
  roomStatus: number;
  statusReason: number;
  serviceComplete: boolean;
  pmVisit: boolean;
}

export interface ICheckoutFormData {
  roomStatus: string;
  statusReason: string;
  actionsTaken: string;
  nextSteps: string;
  resolutionDetails: string;
  serviceComplete: boolean;
  pmVisit: boolean;
}

// ---------------------- Check In

export interface ICheckinRequest {
  bookingId: string;
  userId: string;
  userName: string;
  latitude: number;
  longitude: number;
  address: string;
  deviceType: number;
}
